<pace-authors-header></pace-authors-header>
<div class="main-container">
    <router-outlet></router-outlet>
</div>
